module.exports = __webpack_public_path__ + "img/90.5804240f.jpg";